import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import LiveDetail from "../pages/live/page";
import Search from "../pages/search/page";
import About from "../pages/about/page";
import Help from "../pages/help/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:categoryName",
    element: <Category />,
  },
  {
    path: "/live/:liveId",
    element: <LiveDetail />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/help",
    element: <Help />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;